import React, { createContext } from "react";

export interface ApplicationsContextProps {
    application?: string;
    setApplication?: React.Dispatch<React.SetStateAction<string>>;
}

export const ApplicationsContext = createContext<ApplicationsContextProps>({} as ApplicationsContextProps);